module.exports = __webpack_public_path__ + "img/kommune-1938.78dd2806.svg";